// Mock data for Back and Snacks Bremen

export const mockData = {
  bowls: [
    {
      id: 1,
      name: { de: 'Buddha Bowl', en: 'Buddha Bowl' },
      description: { de: 'Basmati Reis, Kirschtomaten, Paprika, Gurke, Hirtenkäse, Curry-Kichererbsen, Chia-Samen, Schwarzkümmel', en: 'Basmati Rice, Cherry Tomatoes, Bell Pepper, Cucumber, Feta, Curry Chickpeas, Chia Seeds, Black Cumin' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/ses5w5ic_WhatsApp%20Image%202026-01-02%20at%2014.45.27.jpeg',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    },
    {
      id: 2,
      name: { de: 'Rainbow Bowl', en: 'Rainbow Bowl' },
      description: { de: 'Basmati Reis, Rotkohl, Gurke, Karotte, Kidneybohnen, Mais, Paprika', en: 'Basmati Rice, Red Cabbage, Cucumber, Carrot, Kidney Beans, Corn, Bell Pepper' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/4zbzjhf9_WhatsApp%20Image%202026-01-05%20at%2017.33.06.jpeg',
      tags: { de: ['Vegan'], en: ['Vegan'] }
    },
    {
      id: 3,
      name: { de: 'Mediterrane Bowl', en: 'Mediterranean Bowl' },
      description: { de: 'Couscous, Kirschtomaten, Kichererbsen, Paprika, Petersilie, getrocknete Minze, Hummus', en: 'Couscous, Cherry Tomatoes, Chickpeas, Bell Pepper, Parsley, Dried Mint, Hummus' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/8ks2y0cd_WhatsApp%20Image%202026-01-02%20at%2014.49.20.jpeg',
      tags: { de: ['Vegan'], en: ['Vegan'] }
    },
    {
      id: 4,
      name: { de: 'Hähnchen-Sesam Bowl', en: 'Chicken-Sesame Bowl' },
      description: { de: 'Basmati Reis, Hähnchenbrust, Brokkoli, Frühlingszwiebel, Tomaten', en: 'Basmati Rice, Chicken Breast, Broccoli, Spring Onion, Tomatoes' },
      price: 9.90,
      image: 'https://images.unsplash.com/photo-1623428187969-5da2dcea5ebf?w=800',
      tags: { de: ['Protein'], en: ['Protein'] }
    },
    {
      id: 5,
      name: { de: 'Falafel Bowl', en: 'Falafel Bowl' },
      description: { de: 'Mix-Salat, Falafel, Avocado, Karotte, Kirschtomaten, Gurke, geröstete Cashewkerne, Leinsamen', en: 'Mixed Salad, Falafel, Avocado, Carrot, Cherry Tomatoes, Cucumber, Roasted Cashews, Flax Seeds' },
      price: 11.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/t31336m4_WhatsApp%20Image%202026-01-02%20at%2014.48.37.jpeg',
      tags: { de: ['Vegan', 'Beliebt'], en: ['Vegan', 'Popular'] }
    },
    {
      id: 6,
      name: { de: 'Teriyaki Bowl', en: 'Teriyaki Bowl' },
      description: { de: 'Basmati Reis, Hähnchen Teriyaki, Avocado, Gurke, Karotte, Cherrytomaten, Sesam', en: 'Basmati Rice, Teriyaki Chicken, Avocado, Cucumber, Carrot, Cherry Tomatoes, Sesame' },
      price: 11.50,
      image: 'https://images.pexels.com/photos/1860205/pexels-photo-1860205.jpeg?w=800',
      tags: { de: ['Protein', 'Beliebt'], en: ['Protein', 'Popular'] }
    },
    {
      id: 7,
      name: { de: 'Garnelen Bowl', en: 'Shrimp Bowl' },
      description: { de: 'Basmati Reis, Brokkoli, Garnelen, Basilikum-Pesto, Kirschtomaten', en: 'Basmati Rice, Broccoli, Shrimp, Basil Pesto, Cherry Tomatoes' },
      price: 13.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/wy8vkuje_WhatsApp%20Image%202026-01-02%20at%2014.48.11.jpeg',
      tags: { de: ['Premium', 'Protein'], en: ['Premium', 'Protein'] }
    },
    {
      id: 8,
      name: { de: 'Love Vegan Bowl', en: 'Love Vegan Bowl' },
      description: { de: 'Basmati Reis, Tofu, Avocado, Brokkoli, Rotkohl, geröstete Cashewkerne', en: 'Basmati Rice, Tofu, Avocado, Broccoli, Red Cabbage, Roasted Cashews' },
      price: 11.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/zr6b6w9c_WhatsApp%20Image%202026-01-05%20at%2017.34.38.jpeg',
      tags: { de: ['Vegan', 'Protein'], en: ['Vegan', 'Protein'] }
    }
  ],
  pizzas: [
    {
      id: 1,
      name: { de: 'Pizza Papitano', en: 'Pizza Papitano' },
      description: { de: 'Hähnchenbrust, Cherrytomaten, Knoblauchsauce, Basilikum', en: 'Chicken Breast, Cherry Tomatoes, Garlic Sauce, Basil' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800',
      tags: { de: ['Beliebt'], en: ['Popular'] }
    },
    {
      id: 2,
      name: { de: 'Pizza Margherita', en: 'Pizza Margherita' },
      description: { de: 'Tomatensauce, Käse, Oregano', en: 'Tomato Sauce, Cheese, Oregano' },
      prices: { '26cm': 7.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002?w=800',
      tags: { de: ['Klassiker'], en: ['Classic'] }
    },
    {
      id: 3,
      name: { de: 'Pizza Salami', en: 'Pizza Salami' },
      description: { de: 'Salami, rote Paprika', en: 'Salami, Red Bell Pepper' },
      prices: { '26cm': 9.50, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1628840042765-356cda07504e?w=800',
      tags: { de: ['Klassiker'], en: ['Classic'] }
    },
    {
      id: 4,
      name: { de: 'Pizza Hawaii', en: 'Pizza Hawaii' },
      description: { de: 'Schinken, Ananas', en: 'Ham, Pineapple' },
      prices: { '26cm': 9.50, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=800',
      tags: { de: ['Klassiker'], en: ['Classic'] }
    },
    {
      id: 5,
      name: { de: 'Pizza Chicken BBQ', en: 'Pizza Chicken BBQ' },
      description: { de: 'Hähnchenbrust, rote Zwiebeln, Barbecuesauce', en: 'Chicken Breast, Red Onions, BBQ Sauce' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800',
      tags: { de: ['Beliebt'], en: ['Popular'] }
    },
    {
      id: 6,
      name: { de: 'Pizza Ocean', en: 'Pizza Ocean' },
      description: { de: 'Garnelen, Sweet-Chili-Sauce, Rucola', en: 'Shrimp, Sweet Chili Sauce, Arugula' },
      prices: { '26cm': 10.50, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?w=800',
      tags: { de: ['Premium'], en: ['Premium'] }
    },
    {
      id: 7,
      name: { de: 'Pizza Funghi', en: 'Pizza Funghi' },
      description: { de: 'Champignons, Basilikum-Pesto', en: 'Mushrooms, Basil Pesto' },
      prices: { '26cm': 9.50, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1717883235373-ef10b2a745a3?w=800',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    },
    {
      id: 8,
      name: { de: 'Pizza Vegetarisch', en: 'Pizza Vegetarian' },
      description: { de: 'Broccoli, Champignons, Paprika, Oliven, Hirtenkäse', en: 'Broccoli, Mushrooms, Bell Pepper, Olives, Feta' },
      prices: { '26cm': 9.50, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1604068549290-dea0e4a305ca?w=800',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    },
    {
      id: 9,
      name: { de: 'Pizza Lachs', en: 'Pizza Salmon' },
      description: { de: 'Lachswürfel, Spinat, Sauce Hollandaise, Hirtenkäse, Knoblauch', en: 'Salmon Cubes, Spinach, Hollandaise Sauce, Feta, Garlic' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.pexels.com/photos/33457614/pexels-photo-33457614.jpeg?w=800',
      tags: { de: ['Premium'], en: ['Premium'] }
    },
    {
      id: 10,
      name: { de: 'Pizza Amore', en: 'Pizza Amore' },
      description: { de: 'Broccoli, Champignons, Mais, Paprika', en: 'Broccoli, Mushrooms, Corn, Bell Pepper' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.pexels.com/photos/1566837/pexels-photo-1566837.jpeg?w=800',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    },
    {
      id: 11,
      name: { de: 'Pizza Chicken Spezial', en: 'Pizza Chicken Special' },
      description: { de: 'Hähnchenfleisch, Mais, Peperoni', en: 'Chicken, Corn, Peppers' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.pexels.com/photos/31587565/pexels-photo-31587565.jpeg?w=800',
      tags: { de: ['Beliebt'], en: ['Popular'] }
    },
    {
      id: 12,
      name: { de: 'Pizza Texas', en: 'Pizza Texas' },
      description: { de: 'Hähnchenfleisch, Mais, scharfe Peperoni, Currysauce', en: 'Chicken, Corn, Hot Peppers, Curry Sauce' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800',
      tags: { de: ['Scharf'], en: ['Spicy'] }
    },
    {
      id: 13,
      name: { de: 'Pizza Sucuk Spezial', en: 'Pizza Sucuk Special' },
      description: { de: 'Sucuk, rote Zwiebeln, Paprika, Jalapeños, Sauce Hollandaise', en: 'Sucuk, Red Onions, Bell Pepper, Jalapeños, Hollandaise Sauce' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800',
      tags: { de: ['Scharf'], en: ['Spicy'] }
    },
    {
      id: 14,
      name: { de: 'Pizza Rucola', en: 'Pizza Rucola' },
      description: { de: 'Tomaten, Rucola, Parmesan', en: 'Tomatoes, Arugula, Parmesan' },
      prices: { '26cm': 9.90, '32cm': 13.90, '40cm': 19.90 },
      image: 'https://images.pexels.com/photos/7780260/pexels-photo-7780260.jpeg?w=800',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    }
  ],
  baguettes: [
    {
      id: 1,
      name: { de: 'Hanse Chicken Baguette (Signature)', en: 'Hanse Chicken Baguette (Signature)' },
      description: { de: 'Hähnchen, Rucola, Tomaten, Mozzarella, Knoblauch-Sauce', en: 'Chicken, Arugula, Tomatoes, Mozzarella, Garlic Sauce' },
      price: 10.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/rj2til4u_WhatsApp%20Image%202026-01-05%20at%2018.01.40.jpeg',
      tags: { de: ['Signature', 'Beliebt'], en: ['Signature', 'Popular'] }
    },
    {
      id: 2,
      name: { de: 'Chicken BBQ', en: 'Chicken BBQ' },
      description: { de: 'Hähnchenbrust, rote Zwiebeln, BBQ-Sauce, überbacken mit Gouda', en: 'Chicken Breast, Red Onions, BBQ Sauce, baked with Gouda' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/svcj8xw1_WhatsApp%20Image%202026-01-05%20at%2018.10.57.jpeg',
      tags: { de: ['Beliebt'], en: ['Popular'] }
    },
    {
      id: 3,
      name: { de: 'Bombay', en: 'Bombay' },
      description: { de: 'Hähnchenbrust, Ananas, Curry-Sauce', en: 'Chicken Breast, Pineapple, Curry Sauce' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/62s6826a_WhatsApp%20Image%202026-01-05%20at%2018.06.32.jpeg',
      tags: { de: ['Mild'], en: ['Mild'] }
    },
    {
      id: 4,
      name: { de: 'Boston', en: 'Boston' },
      description: { de: 'Salami, Paprika, Knoblauch-Sauce', en: 'Salami, Bell Pepper, Garlic Sauce' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/fle311bj_WhatsApp%20Image%202026-01-05%20at%2018.08.58.jpeg',
      tags: { de: ['Herzhaft'], en: ['Hearty'] }
    },
    {
      id: 5,
      name: { de: 'Italian', en: 'Italian' },
      description: { de: 'Tomaten, Mozzarella, Rucola, Joghurt-Pesto-Sauce', en: 'Tomatoes, Mozzarella, Arugula, Yogurt-Pesto Sauce' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/2fuqmmb4_WhatsApp%20Image%202026-01-05%20at%2018.10.26.jpeg',
      tags: { de: ['Vegetarisch', 'Klassiker'], en: ['Vegetarian', 'Classic'] }
    },
    {
      id: 6,
      name: { de: 'Chicken Hollandaise', en: 'Chicken Hollandaise' },
      description: { de: 'Hähnchenbrust, rote Zwiebeln, Sauce Hollandaise', en: 'Chicken Breast, Red Onions, Hollandaise Sauce' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/kcwad8m2_WhatsApp%20Image%202026-01-05%20at%2018.08.58.jpeg',
      tags: { de: ['Cremig', 'Beliebt'], en: ['Creamy', 'Popular'] }
    },
    {
      id: 7,
      name: { de: 'Tonno', en: 'Tonno' },
      description: { de: 'Thunfisch, rote Zwiebeln, Knoblauch-Sauce', en: 'Tuna, Red Onions, Garlic Sauce' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/r7ztxhtq_WhatsApp%20Image%202026-01-05%20at%2018.11.03.jpeg',
      tags: { de: ['Mediterran'], en: ['Mediterranean'] }
    },
    {
      id: 8,
      name: { de: 'Veggie', en: 'Veggie' },
      description: { de: 'Paprika, Oliven, Hirtenkäse, Joghurt-Sauce', en: 'Bell Pepper, Olives, Feta, Yogurt Sauce' },
      price: 10.50,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/smenvbov_WhatsApp%20Image%202026-01-05%20at%2018.10.26.jpeg',
      tags: { de: ['Vegetarisch', 'Frisch'], en: ['Vegetarian', 'Fresh'] }
    }
  ],
  burgers: [
    {
      id: 1,
      name: { de: 'Hamburger', en: 'Hamburger' },
      description: { de: 'Saftiges Rindfleisch, Salat, Tomaten, Gurken, rote Zwiebeln', en: 'Juicy Beef, Lettuce, Tomatoes, Pickles, Red Onions' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/ahfcru6r_WhatsApp%20Image%202026-01-05%20at%2018.26.48.jpeg',
      tags: { de: ['Klassiker'], en: ['Classic'] }
    },
    {
      id: 2,
      name: { de: 'Cheeseburger', en: 'Cheeseburger' },
      description: { de: 'Saftiges Rindfleisch, Cheddar-Käse, Salat, Tomaten, Gurken, rote Zwiebeln', en: 'Juicy Beef, Cheddar Cheese, Lettuce, Tomatoes, Pickles, Red Onions' },
      price: 10.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/hwl4172z_WhatsApp%20Image%202026-01-05%20at%2018.28.13.jpeg',
      tags: { de: ['Beliebt'], en: ['Popular'] }
    },
    {
      id: 3,
      name: { de: 'Veggie Burger', en: 'Veggie Burger' },
      description: { de: 'Veggie-Patty, Salat, Tomaten, Gurken, rote Zwiebeln, Joghurt-Sauce', en: 'Veggie Patty, Lettuce, Tomatoes, Pickles, Red Onions, Yogurt Sauce' },
      price: 8.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/fq2jm0fz_WhatsApp%20Image%202026-01-05%20at%2018.29.50.jpeg',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    },
    {
      id: 4,
      name: { de: 'Crispy Chicken Burger', en: 'Crispy Chicken Burger' },
      description: { de: 'Knuspriges Hähnchenschnitzel, Salat, Tomaten, Gurken, Mayonnaise', en: 'Crispy Chicken Schnitzel, Lettuce, Tomatoes, Pickles, Mayonnaise' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/r2ts5fxl_WhatsApp%20Image%202026-01-05%20at%2018.32.10.jpeg',
      tags: { de: ['Beliebt'], en: ['Popular'] }
    }
  ],
  salads: [
    {
      id: 1,
      name: { de: 'Salat Chef', en: 'Chef Salad' },
      description: { de: 'Römersalat, Schinken, Käse, Ei, Gurken, Kirschtomaten, Mais', en: 'Romaine Lettuce, Ham, Cheese, Egg, Cucumber, Cherry Tomatoes, Corn' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/ejltzk1m_WhatsApp%20Image%202026-01-02%20at%2014.47.54.jpeg',
      tags: { de: ['Protein'], en: ['Protein'] }
    },
    {
      id: 2,
      name: { de: 'Salat Caesar Hähnchen', en: 'Caesar Chicken Salad' },
      description: { de: 'Römersalat, Hähnchenbrust, Tomaten, Gurken, Paprika, Croutons, Parmesan', en: 'Romaine Lettuce, Chicken Breast, Tomatoes, Cucumber, Bell Pepper, Croutons, Parmesan' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/u4gou4mu_WhatsApp%20Image%202026-01-02%20at%2014.47.44.jpeg',
      tags: { de: ['Beliebt', 'Protein'], en: ['Popular', 'Protein'] }
    },
    {
      id: 3,
      name: { de: 'Salat Griechisch', en: 'Greek Salad' },
      description: { de: 'Römersalat, Kirschtomaten, Gurken, Oliven, Hirtenkäse, milde Peperoni', en: 'Romaine Lettuce, Cherry Tomatoes, Cucumber, Olives, Feta, Mild Peppers' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/5lawg0p6_WhatsApp%20Image%202026-01-02%20at%2014.47.17.jpeg',
      tags: { de: ['Vegetarisch', 'Beliebt'], en: ['Vegetarian', 'Popular'] }
    },
    {
      id: 4,
      name: { de: 'Salat Thunfisch', en: 'Tuna Salad' },
      description: { de: 'Römersalat, Gurken, Tomaten, rote Zwiebeln, Mais', en: 'Romaine Lettuce, Cucumber, Tomatoes, Red Onions, Corn' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/ywwqsnw8_WhatsApp%20Image%202026-01-02%20at%2014.47.30.jpeg',
      tags: { de: ['Protein'], en: ['Protein'] }
    },
    {
      id: 5,
      name: { de: 'Salat Tomate Mozzarella', en: 'Tomato Mozzarella Salad' },
      description: { de: 'Rucolasalat, Kirschtomaten, Gurken, rote Zwiebeln', en: 'Arugula, Cherry Tomatoes, Cucumber, Red Onions' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/npravbx2_WhatsApp%20Image%202026-01-02%20at%2014.46.49.jpeg',
      tags: { de: ['Vegetarisch'], en: ['Vegetarian'] }
    },
    {
      id: 6,
      name: { de: 'Salat Garnelen', en: 'Shrimp Salad' },
      description: { de: 'Garnelen, Croutons, Parmesan', en: 'Shrimp, Croutons, Parmesan' },
      price: 9.90,
      image: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/vgt3wpjo_WhatsApp%20Image%202026-01-02%20at%2014.46.32.jpeg',
      tags: { de: ['Premium', 'Protein'], en: ['Premium', 'Protein'] }
    }
  ],
  dressings: [
    { name: { de: 'Joghurt', en: 'Yogurt' }, icon: 'droplet' },
    { name: { de: 'French', en: 'French' }, icon: 'droplet' },
    { name: { de: 'Honig-Senf', en: 'Honey Mustard' }, icon: 'droplet' },
    { name: { de: 'Kräuter', en: 'Herbs' }, icon: 'droplet' },
    { name: { de: 'Essig & Öl', en: 'Vinegar & Oil' }, icon: 'droplet' },
    { name: { de: 'Balsamico', en: 'Balsamic' }, icon: 'droplet' }
  ],
  mittagessen: {
    title: { de: 'Mittagessen', en: 'Weekly Lunch Menu' },
    subtitle: { de: 'Unser Mittagessen wechselt jede Woche', en: 'Our lunch menu changes every week' },
    note: { de: 'Montag - Freitag, 11:00 - 15:00', en: 'Monday - Friday, 11:00 AM - 3:00 PM' },
    weeklyMenu: {
      monday: {
        menu1: { de: 'Fusilli mit Hähnchen, Brokkoli & Tomaten-Sahne-Soße, dazu Parmesan', en: 'Fusilli with Chicken, Broccoli & Tomato Cream Sauce, with Parmesan' },
        menu2: { de: 'Spinat-Käse-Spätzle mit Röstzwiebeln', en: 'Spinach Cheese Spätzle with Roasted Onions' }
      },
      tuesday: {
        menu1: { de: 'Cremiges Hähnchen-Champignon-Curry mit Basmati-Reis', en: 'Creamy Chicken Mushroom Curry with Basmati Rice' },
        menu2: { de: 'Gefüllte Paprika mit Couscous & Feta', en: 'Stuffed Bell Peppers with Couscous & Feta' }
      },
      wednesday: {
        menu1: { de: 'Spaghetti Bolognese mit Rinderhackfleisch & Parmesan', en: 'Spaghetti Bolognese with Ground Beef & Parmesan' },
        menu2: { de: 'Schupfnudeln-Gemüse-Pfanne mit Paprika, Zucchini & Kräutern', en: 'Potato Noodle Vegetable Pan with Bell Pepper, Zucchini & Herbs' }
      },
      thursday: {
        menu1: { de: 'Indisches Butter Chicken Masala mit Basmati-Reis', en: 'Indian Butter Chicken Masala with Basmati Rice' },
        menu2: { de: 'Gemüse-Tofu-Curry in Kokosmilch mit Basmati-Reis', en: 'Vegetable Tofu Curry in Coconut Milk with Basmati Rice' }
      },
      friday: {
        menu1: { de: 'Lasagne mit Rinderhackfleisch & Béchamelsauce', en: 'Lasagne with Ground Beef & Béchamel Sauce' }
      }
    }
  },
  reviews: [
    {
      name: 'Anna M.',
      rating: 5,
      text: { de: 'Sehr frisch und lecker. Perfekt für die Mittagspause!', en: 'Very fresh and delicious. Perfect for lunch break!' }
    },
    {
      name: 'Thomas K.',
      rating: 5,
      text: { de: 'Top Qualität, gerne wieder. Die Bowls sind fantastisch!', en: 'Top quality, will come again. The bowls are fantastic!' }
    },
    {
      name: 'Sarah L.',
      rating: 5,
      text: { de: 'Eines der besten Restaurants in der Gegend. Sehr empfehlenswert!', en: 'One of the best restaurants in the area. Highly recommended!' }
    },
    {
      name: 'Michael B.',
      rating: 5,
      text: { de: 'Frische Zutaten, faire Preise, freundlicher Service!', en: 'Fresh ingredients, fair prices, friendly service!' }
    }
  ],
  deliveryPartners: [
    { name: 'Lieferando', url: 'https://www.lieferando.de/speisekarte/back-snacks', logo: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/i8z04mcs_image.png' },
    { name: 'Wolt', url: 'https://wolt.com/de/deu/bremen/restaurant/back-snacks-neustadt', logo: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/rngg7hzo_image.png' },
    { name: 'Uber Eats', url: 'https://www.ubereats.com/de/store/back-%26-snacks/cTNFBxdnR9mVVXQv3W28bg', logo: 'https://customer-assets.emergentagent.com/job_bremenfoodspot/artifacts/tqwpronc_image.png' }
  ],
  contact: {
    address: 'Industriestraße 12a, 28199 Bremen',
    phone: '+49 421 57843663',
    hours: { de: '11:00 - 22:00', en: '11:00 AM - 10:00 PM' },
    email: 'info@backandsnacks.de'
  },
  social: {
    instagram: 'https://www.instagram.com/backandsnacksbremen',
    facebook: 'https://www.facebook.com/share/1DDv1dXVUC/'
  }
};
